// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import type { Theme } from '../../types';
import type { ButtonSchemeName, ButtonVariant } from '../../types/theme';
import { getValueOrArrayHead } from '../../helpers';
import type { Position } from './types';
import ListoButton from './button';

export type ButtonContainerProps = {|
  children: Node,
  className?: ?string,
  colors: ButtonSchemeName,
  disabled?: ?boolean,
  href: ?string,
  icon?: string | Array<string>,
  position: Position,
  size: string,
  variant: ButtonVariant,
  withIcon?: boolean,
  type?: ?string,
|};

const Icon = styled<any, Theme>('i')`
  font-size: 1.5rem;
  padding-right: .5rem;
  &:before {
    vertical-align: middle;
  }
`;

const ButtonContainer = ({
  children,
  className,
  colors,
  disabled,
  href,
  icon,
  position,
  size,
  variant,
  withIcon = false,
  type,
}: ButtonContainerProps) => (
  <ListoButton
    className={className}
    variant={variant}
    colors={colors}
    disabled={disabled}
    position={position}
    href={href}
    caret={!withIcon}
    size={size}
    withIcon={withIcon}
    type={type}
  >
    {withIcon && icon && <Icon className={`icon-${getValueOrArrayHead(icon)}`} />}
    {children}
  </ListoButton>
);

ButtonContainer.defaultProps = {
  className: '',
  disabled: false,
  icon: '',
  withIcon: false,
  type: null,
};

export default ButtonContainer;
